import axios from 'axios'
import { PageDataResponse ,PageResponse,DataObjectResponse, DataArrayResponse } from '../models/PageResponse'
import { Parameter,QueryDataModel,RequestCollectCarton,RequestDetail , 
    RequestUpdateStatus ,UpdateCollectCarton ,DataNote,CartonList} from '../models'
import { config } from '../config'
import { CookieHelper } from '../helpers'

const apiUrl = config.API_URL

export default class CollectCartonService
{
    protected headers = {
        'Content-Type': 'application/json',
        'Authorization': "",
        'X-XSRF-TOKEN': ""
    }
    protected token = ""
    constructor(token:string | null){
        if(token){
            this.token = token
            this.headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'X-XSRF-TOKEN': ""
            }
        }
        
    }
    
    async GetRequest(id:number ){
        if(!this.token) return null

        let xsrfToken = await CookieHelper.getCookie(this.token)
        this.headers['X-XSRF-TOKEN'] = xsrfToken

        let options = {
                headers:this.headers
            }
        
        const { data }  = await axios.post<DataObjectResponse<RequestDetail>>(`${apiUrl}/v1/collect/request?id=${id}`, {},options )
        
        return data;
    }

    async GetDetail(id:number ){
        if(!this.token) return null

        let xsrfToken = await CookieHelper.getCookie(this.token)
        this.headers['X-XSRF-TOKEN'] = xsrfToken
        
        let options = {
                headers:this.headers
            }
        
        const { data }  = await axios.post<DataObjectResponse<RequestDetail>>(`${apiUrl}/v1/collect/detail?id=${id}`, {},options )
        
        return data;
    }

    async GetExtendDetail(id:string ){
        if(!this.token) return null

        let xsrfToken = await CookieHelper.getCookie(this.token)
        this.headers['X-XSRF-TOKEN'] = xsrfToken
        
        let options = {
                headers:this.headers
            }
        
        const { data }  = await axios.post<DataArrayResponse<RequestDetail>>(`${apiUrl}/v1/collect/extend/detail?id=${id}`, {},options )
        
        return data;
    }

    async GetCartonList(id:number ){
        if(!this.token) return null
        let options = {
                headers:this.headers
            }
        
        const { data }  = await axios.get<DataArrayResponse<CartonList>>(`${apiUrl}/v1/collect/cartonlist?id=${id}`, options )
        
        return data;
    }

    async GetNote(id:number ){
        if(!this.token) return null
        let options = {
                headers:this.headers
            }
        
        const { data }  = await axios.get<DataArrayResponse<DataNote>>(`${apiUrl}/v1/collect/note?id=${id}`, options )
        
        return data;
    }

    async Search(parameter: Parameter) {
        if (!this.token) return null

        let xsrfToken = await CookieHelper.getCookie(this.token)
        this.headers['X-XSRF-TOKEN'] = xsrfToken

        let options = {
            headers:this.headers,
        }
        const { data }   = await axios.post<PageDataResponse<QueryDataModel>>(`${apiUrl}/v1/collect/search`,JSON.stringify(parameter),options )
        return data;
    }

    async SearchDraft(parameter: Parameter) {
        if (!this.token) return null

        let xsrfToken = await CookieHelper.getCookie(this.token)
        this.headers['X-XSRF-TOKEN'] = xsrfToken

        let options = {
            headers:this.headers,
        }
        const { data }   = await axios.post<PageDataResponse<QueryDataModel>>(`${apiUrl}/v1/collect/searchdraft`,JSON.stringify(parameter),options )
        return data;
    }

    async SearchCarton(parameter: Parameter) {
        if (!this.token) return null

        let xsrfToken = await CookieHelper.getCookie(this.token)
        this.headers['X-XSRF-TOKEN'] = xsrfToken

        if(!this.token) return null
        let options = {
                headers:this.headers
            }
        
        const { data }  = await axios.post<PageDataResponse<CartonList>>(`${apiUrl}/v1/collect/searchcarton`, JSON.stringify(parameter),options )
        
        return data;
    }

    async SearchReturnRequest(parameter: Parameter) {
        if (!this.token) return null

        let xsrfToken = await CookieHelper.getCookie(this.token)
        this.headers['X-XSRF-TOKEN'] = xsrfToken

        if(!this.token) return null
        let options = {
                headers:this.headers
            }
        
        const { data }  = await axios.post<PageDataResponse<CartonList>>(`${apiUrl}/v1/collect/search/return/request`, JSON.stringify(parameter),options )
        
        return data;
    }

    async SearchRemoveRequest(parameter: Parameter) {
        if (!this.token) return null

        let xsrfToken = await CookieHelper.getCookie(this.token)
        this.headers['X-XSRF-TOKEN'] = xsrfToken

        if(!this.token) return null
        let options = {
                headers:this.headers
            }
        
        const { data }  = await axios.post<PageDataResponse<CartonList>>(`${apiUrl}/v1/collect/search/remove/request`, JSON.stringify(parameter),options )
        
        return data;
    }

    async Create(request: RequestCollectCarton) {
        if (!this.token) return null

        let xsrfToken = await CookieHelper.getCookie(this.token)
        this.headers['X-XSRF-TOKEN'] = xsrfToken

        let options = {
            headers:this.headers
        }
        const { data }   = await axios.post<PageResponse>(`${apiUrl}/v1/collect/create`,JSON.stringify(request),options )
        return data;
    }


    async Update(request: RequestCollectCarton) {
        if (!this.token) return null

        let xsrfToken = await CookieHelper.getCookie(this.token)
        this.headers['X-XSRF-TOKEN'] = xsrfToken

        let options = {
            headers:this.headers
        }
        const { data }   = await axios.post<PageResponse>(`${apiUrl}/v1/collect/update`,JSON.stringify(request),options )
        return data;
    }

    async UpdateAdmin(request: UpdateCollectCarton) {
        if (!this.token) return null

        let xsrfToken = await CookieHelper.getCookie(this.token)
        this.headers['X-XSRF-TOKEN'] = xsrfToken

        let options = {
            headers:this.headers
        }
        const { data }   = await axios.post<PageResponse>(`${apiUrl}/v1/collect/admin/update`,JSON.stringify(request),options )
        return data;
    }

    async UpdateStatus(requestUpdateStatus: RequestUpdateStatus) {
        if (!this.token) return null

        let xsrfToken = await CookieHelper.getCookie(this.token)
        this.headers['X-XSRF-TOKEN'] = xsrfToken

        let options = {
            headers:this.headers
        }
        const { data }   = await axios.post<PageResponse>(`${apiUrl}/v1/collect/status/update`,JSON.stringify(requestUpdateStatus),options )
        return data;
    }

    async DeleteCarton(ids: number[]) {
        if (!this.token) return null

        let xsrfToken = await CookieHelper.getCookie(this.token)
        this.headers['X-XSRF-TOKEN'] = xsrfToken

        let options = {
            headers:this.headers
        }
        const { data }   = await axios.post<PageResponse>(`${apiUrl}/v1/collect/deletecarton`,JSON.stringify(ids),options )
        return data;
    }

}